/** Настройки зрителя: яркость вспышек и сила тряски, 0–100 %. Хранятся в браузере, без него — по умолчанию. */
export interface ViewSettings {
  flash: number;
  shake: number;
}

export const DEFAULT_SETTINGS: ViewSettings = { flash: 70, shake: 100 };
const KEY = "blood-arena.settings";

const clampPercent = (value: unknown, fallback: number): number =>
  typeof value === "number" && Number.isFinite(value) ? Math.min(100, Math.max(0, Math.round(value))) : fallback;

export function loadSettings(storage: Storage | undefined): ViewSettings {
  try {
    const raw = storage?.getItem(KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : {};
    const record = (parsed ?? {}) as Partial<Record<keyof ViewSettings, unknown>>;
    return {
      flash: clampPercent(record.flash, DEFAULT_SETTINGS.flash),
      shake: clampPercent(record.shake, DEFAULT_SETTINGS.shake),
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(storage: Storage | undefined, settings: ViewSettings): void {
  try {
    storage?.setItem(KEY, JSON.stringify(settings));
  } catch {
    // приватное окно или запрет хранилища: настройки живут до перезагрузки
  }
}
